import React from 'react';
import { Outlet, NavLink, Link, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { ADMIN_BASE, ADMIN_LOGIN_PATH } from '../../lib/api';

export default function AdminLayout() {
  const { user, checking, logout } = useAuth();
  const loc = useLocation();

  if (checking) {
    return (
      <div className="admin-loading">
        <i className="fa-solid fa-spinner fa-spin"></i>
        <span>Loading admin…</span>
      </div>
    );
  }

  if (!user) {
    return <Navigate to={ADMIN_LOGIN_PATH} state={{ from: loc.pathname }} replace />;
  }

  return (
    <div className="admin-shell">
      <aside className="admin-aside">
        <Link to={ADMIN_BASE} className="logo admin-aside-logo">
          <span className="logo-mark"><span>N</span></span>
          <div>
            <strong>Nathanael</strong>
            <span>Admin</span>
          </div>
        </Link>

        <nav className="admin-nav">
          <NavLink end to={ADMIN_BASE} className="admin-nav-link" data-testid="admin-nav-products">
            <i className="fa-solid fa-boxes-stacked"></i>
            <span>Products</span>
          </NavLink>
          <NavLink to={`${ADMIN_BASE}/orders`} className="admin-nav-link" data-testid="admin-nav-orders">
            <i className="fa-solid fa-receipt"></i>
            <span>Orders</span>
          </NavLink>
          <NavLink to={`${ADMIN_BASE}/banners`} className="admin-nav-link" data-testid="admin-nav-banners">
            <i className="fa-solid fa-image"></i>
            <span>Banners</span>
          </NavLink>
          <NavLink to={`${ADMIN_BASE}/settings`} className="admin-nav-link" data-testid="admin-nav-settings">
            <i className="fa-solid fa-gear"></i>
            <span>Settings</span>
          </NavLink>
          <NavLink to={`${ADMIN_BASE}/products/new`} className="admin-nav-link" data-testid="admin-nav-new">
            <i className="fa-solid fa-plus"></i>
            <span>New product</span>
          </NavLink>
          <a href="/" target="_blank" rel="noopener noreferrer" className="admin-nav-link">
            <i className="fa-solid fa-arrow-up-right-from-square"></i>
            <span>View site</span>
          </a>
        </nav>

        <div className="admin-aside-foot">
          <div className="admin-user">
            <div className="admin-avatar">{(user.email || 'A')[0].toUpperCase()}</div>
            <div className="admin-user-info">
              <strong>{user.name || 'Admin'}</strong>
              <span>{user.email}</span>
            </div>
          </div>
          <button className="btn btn-ghost" onClick={logout} data-testid="admin-logout-btn">
            <i className="fa-solid fa-arrow-right-from-bracket"></i>
            <span>Sign out</span>
          </button>
        </div>
      </aside>

      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
}
